module.exports = __webpack_public_path__ + "img/butterfly.262e0efc.png";